import React from "react";
import { Modal,View, Text, Image, TouchableOpacity, Dimensions } from "react-native";
import { TouchableWithoutFeedback } from "react-native-web";
import api from "../config/api_urls";


import style from "./style";

//todo introduir traduccións al nom del premi
function PopUpPerfilImatge(currentPremi,modalVisible,setModalVisible,idioma)
{

    return (
        <Modal
        animationType="slide"
        transparent={true}
        ariaHideApp={false}
        style={{backgroundColor:'rgba(16, 16, 16, 0.47)' , position:'absolute', top:0, left:0, right:0, bottom:0, zIndex:1000, width:'100%', height:'100%'}}
        onBackdropPress={() => { setModalVisible(false); }}
        visible={modalVisible}
        >
        <View style={{ marginTop: 22 }}>
        <TouchableWithoutFeedback onPress={() => {setModalVisible(false);}}>

        <View style={{marginTop: Dimensions.get('screen').height * (13 / 15) * 0.22 , maxHeight: Dimensions.get('screen').height * (13 / 15) * 0.67 ,paddingBottom: Dimensions.get('screen').width * 0.2 , marginHorizontal:'10%'}}>
          <View style={[style.caixaOut,] }>
            <View style={[style.caixa ]}>
              <View style={[style.caixa,{marginTop:30}]}> 
                <Image style={style.imatgeClick} source={{ uri: api.api_url + currentPremi.Premi?.url}} />
                <Text style={style.textImatge}>{currentPremi['descripcio'+idioma] ? currentPremi['descripcio'+idioma] : currentPremi['Nom'+idioma]}  </Text>
              </View>
            </View>
          </View>
        </View>
      </TouchableWithoutFeedback>
      </View>
      </Modal>

    )
}

export default PopUpPerfilImatge;